const getMediaGroupId = (items) => {
  if (!items || items.length === 0) return null;

  return items[0].mediaGroupId;
};

export default getMediaGroupId;
